import Entity from "../../core/entity/Entity";
import { RunEntity } from "../LevelEntity";

export default class ScoreManager extends RunEntity implements Entity {
  id = "scoreManager";
  private _score: number = 0;

  get score(): number {
    return this._score;
  }

  onScoreAdded(eventData: { points: number }) {
    this._score += eventData.points;
  }

  resetScore() {
    this._score = 0;
  }
}
